import React, { Fragment } from "react";
import { defineMessages, injectIntl, intlShape } from "react-intl";
import PropTypes from "prop-types";

import { noop } from "shared-frontend/functions/noop";
import { SelectField } from "@yoast/ui-library";

const messages = defineMessages( {
	selectExistingSite: {
		id: "install.select.orChooseExisting",
		defaultMessage: "Select an existing site",
	},
	selectExistingSitePlaceholder: {
		id: "install.select.selectExistingPlaceholder",
		defaultMessage: "Select site",
	},
} );

/**
 * Renders the SelectExistingSite component.
 *
 * @param {object} props The properties.
 *
 * @returns {ReactElement} The SelectExistingSite component.
 */
const SelectExistingSite = ( props ) => {
	/**
	 * Passes selected value of the select field.
	 *
	 * @param {string} value The selected value.
	 *
	 * @returns {void}
	 */
	function onChange( value ) {
		try {
			props.selectionChanged( new URL( value ) );
		} catch {
			// If the value is not a valid URL, consider nothing selected.
			props.selectionChanged( null );
		}
	}

	/**
	 * Ensures only valid site URLs are part of the options.
	 * @param {string} url site URl.
	 * @returns {boolean} True if the URL is valid, false otherwise.
	 */
	function onlyValidSiteUrl( url ) {
		try {
			const mySite = new URL( url );
			return !! mySite.href;
		} catch ( e ) {
			return false;
		}
	}

	const wordPressSites = props.existingSites
		.filter( site => site.type === "wordpress" )
		.filter( site => onlyValidSiteUrl( site.url ) )
		.map( site => (
			{
				value: new URL( site.url ).href,
				label: site.url,
			} ) );

	return (
		<>
			<SelectField
				id="select-previously-added-site"
				name="selectSite"
				label={ props.intl.formatMessage( messages.selectExistingSite ) }
				value={ props.selectedSiteUrl?.href || "" }
				onChange={ value => onChange( value ) }
				disabled={ props.disabled }
				options={ [
					{ value: "", label: props.intl.formatMessage( messages.selectExistingSitePlaceholder ) },
					...wordPressSites,
				] }
			/>
		</>
	);
};

SelectExistingSite.propTypes = {
	selectedSiteUrl: PropTypes.instanceOf( URL ),
	selectionChanged: PropTypes.func,
	existingSites: PropTypes.array,
	disabled: PropTypes.bool,
	intl: intlShape.isRequired,
};

SelectExistingSite.defaultProps = {
	selectedSiteUrl: "",
	selectionChanged: noop,
	existingSites: [],
	disabled: false,
};

export default injectIntl( SelectExistingSite );
